import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AsyncState } from '@peca/backoffice/models/async-state.model';
import { PurchaseOrderService } from '../../../services/purchase.service';
import { PurchaseOrderIntegrateLog } from '../../../models/purchase-order/purchase-order-integrate-log.model';

type State = AsyncState<PurchaseOrderIntegrateLog[]>;

@Component({
    selector: 'peca-purchase-order-details-integrate-logs',
    templateUrl: './purchase-order-details-integrate-logs.component.html',
    styleUrls: ['./purchase-order-details-integrate-logs.component.scss'],
    standalone: false,
})
export class PurchaseorderDetailsIntegrateLogsComponentComponent implements OnInit {
    purchaseOrderService: PurchaseOrderService;
    route: ActivatedRoute;
    integrateLogs$: BehaviorSubject<State>;

    @Input()
    orderId = '';

    constructor() {
        this.purchaseOrderService = inject(PurchaseOrderService);
        this.route = inject(ActivatedRoute);
        this.integrateLogs$ = new BehaviorSubject<State>({ loading: true });
    }

    get id() {
        if (!this.orderId) return this.route.snapshot.parent?.params['id'] as string;
        return this.orderId as string;
    }

    ngOnInit() {
        this.fetchIntegrateLogs(this.id);
    }

    fetchIntegrateLogs(id: string) {
        this.integrateLogs$.next({ loading: true });
        this.purchaseOrderService.fetchIntegrateLogs(id).subscribe({
            next: (data) => this.integrateLogs$.next({ data }),
            error: () => this.integrateLogs$.next({ failure: true }),
        });
    }

    onRetry() {
        this.fetchIntegrateLogs(this.id);
    }
}
